// pt-BR labels derived from api values. The UI renders what the api says:
// recording status and speakers are never inferred.
import { RECORDING_UNAVAILABLE_LABEL, SHARED_MIC_LABEL } from '@kima-hub/contracts';
import type { MeetingStatus, PersonRef, RecordingStatus, SpeakerKind } from '@kima-hub/contracts';
import { COPY } from '../copy.js';

export function speakerLabel(kind: SpeakerKind | null, speaker: PersonRef | null): string {
  if (kind === 'shared_mic') return SHARED_MIC_LABEL;
  return speaker?.display_name || COPY.unknownSpeaker;
}

/** "sem gravação disponível" plus the reason, or null when recorded. */
export function recordingUnavailableText(status: RecordingStatus | null): string | null {
  if (!status || status.mode !== 'unavailable') return null;
  const reason = status.unavailable_reason ? COPY.unavailableReason[status.unavailable_reason] : null;
  return reason ? `${RECORDING_UNAVAILABLE_LABEL} — ${reason}` : RECORDING_UNAVAILABLE_LABEL;
}

const STATUS_LABELS: Record<MeetingStatus, string> = {
  live: 'ao vivo',
  closing: 'encerrando',
  reconciling: 'conferindo gravações',
  transcribing: 'transcrevendo',
  summarizing: 'resumindo',
  done: 'concluída',
  partial: 'parcial',
  failed: 'falhou',
};

export function statusLabel(status: MeetingStatus): string {
  return STATUS_LABELS[status];
}

export function isProcessing(status: MeetingStatus): boolean {
  return status !== 'done' && status !== 'partial' && status !== 'failed';
}

const dateFormat = new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short' });

export function formatDate(iso: string | null): string {
  if (!iso) return '—';
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? '—' : dateFormat.format(date);
}

/** mm:ss or h:mm:ss for a ms offset. */
export function formatClock(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const mm = String(m).padStart(h > 0 ? 2 : 1, '0');
  const ss = String(s).padStart(2, '0');
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}
